import React from 'react';

import RegionalOrganization from '../components/RegionalOrganization';

class RegionalOrganizationLandingPage extends React.Component {
  render() {
    return (
      <div>
        <h2>
          Regional Organizations
        </h2>

        <RegionalOrganization />
      </div>
    );
  }
}

export default RegionalOrganizationLandingPage;



// WEBPACK FOOTER //
// ./src/pages/RegionalOrganization.js